import SearchableSelect, { type SearchableSelectOption } from './SearchableSelect';

export type FlowPickerOption = SearchableSelectOption & {
  isQuiz?: boolean;
};

type FlowPickerProps = {
  value: string;
  onValueChange: (value: string) => void;
  options: FlowPickerOption[];
  placeholder: string;
  searchPlaceholder?: string;
  searchTerm?: string;
  onSearchTermChange?: (value: string) => void;
  loading?: boolean;
  emptyMessage?: string;
  sentinelOption?: SearchableSelectOption;
  disabled?: boolean;
  triggerId?: string;
  triggerClassName?: string;
  contentClassName?: string;
  inputTestId?: string;
  maxVisibleOptions?: number;
};

export const FlowPicker: React.FC<FlowPickerProps> = ({
  searchPlaceholder = 'Search modules...',
  ...props
}) => (
  <SearchableSelect
    {...props}
    searchPlaceholder={searchPlaceholder}
    renderOption={(option) => {
      const flowOption = option as FlowPickerOption;
      return flowOption.isQuiz ? `${flowOption.label} (Quiz)` : flowOption.label;
    }}
  />
);

export default FlowPicker;
